import type { RoleKey } from '@qlk/shared';
import { ROLE_KEYS, ROLE_LABEL } from '@qlk/shared';
import { useState } from 'react';

import { HopThoai, Nut, OChon } from '../../../ui/index.js';
import { useMoiThanhVien } from '../api.js';
import { ThongBaoMail } from './KhoiLinkDatMatKhau.js';

export interface DialogMoiThanhVienProps {
  onDong: () => void;
}

export function DialogMoiThanhVien({ onDong }: DialogMoiThanhVienProps) {
  const moi = useMoiThanhVien();

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [roleKey, setRoleKey] = useState<RoleKey>('collaborator');

  const hopLe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && name.trim().length > 0;

  return (
    <HopThoai
      title="Mời thành viên"
      rong="sm"
      onDong={onDong}
      chanHop={
        <>
          <Nut kieu="phu" onClick={onDong}>
            {moi.data ? 'Đóng' : 'Huỷ'}
          </Nut>
          <Nut
            kieu="chinh"
            disabled={!hopLe}
            dangChay={moi.isPending}
            onClick={() => {
              moi.mutate({ email: email.trim(), name: name.trim(), roleKey });
            }}
          >
            Gửi lời mời
          </Nut>
        </>
      }
    >
      <p className="text-phu text-chu-mo">
        Hệ thống tạo tài khoản ở trạng thái "đã mời" và gửi link đặt mật khẩu. Chưa cấu hình email
        thì link vẫn tạo, bạn sao chép gửi tay.
      </p>

      <div className="mt-4 space-y-4">
        <div>
          <label htmlFor="moi-email" className="mb-1 block text-phu font-medium text-chu-phu">
            Email
          </label>
          <input
            id="moi-email"
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            className="vung-bam w-full rounded-[10px] border border-vien px-3 text-co-ban text-chu"
            placeholder="ten@wmmedia.local"
          />
        </div>

        <div>
          <label htmlFor="moi-ten" className="mb-1 block text-phu font-medium text-chu-phu">
            Họ tên
          </label>
          <input
            id="moi-ten"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            className="vung-bam w-full rounded-[10px] border border-vien px-3 text-co-ban text-chu"
          />
        </div>

        <OChon
          hienNhan
          label="Vai trò"
          value={roleKey}
          onChange={(v) => {
            setRoleKey(v as RoleKey);
          }}
          options={ROLE_KEYS.map((k) => ({ value: k, label: ROLE_LABEL[k] }))}
          className="w-full"
        />
      </div>

      {moi.isError && (
        <p role="alert" className="mt-3 text-phu text-bad-chu">
          {moi.error.message}
        </p>
      )}

      {moi.data && (
        <ThongBaoMail ketQua={moi.data} tieuDe={`Đã tạo lời mời cho ${moi.data.email}`} />
      )}
    </HopThoai>
  );
}
